import { actionCreatorFactory } from 'typescript-fsa';

const ac = actionCreatorFactory('cart');

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PushCartEditParam {}

// eslint-disable-next-line @typescript-eslint/no-empty-interface
export interface PushCartEditResult {}

export interface PushCartEditError {
    status: number;
    statusText: string;
}

export const pushCartEditAction = ac.async<
    PushCartEditParam, PushCartEditResult, PushCartEditError>('pushCartEditAction');
